import screenBreakpoints from '@/assets/scss/breakpoints.module.scss'

export function useBreakpoints() {
  const breakpoints = reactive({
    xsOnly: false,
    smAndDown: false,
    smOnly: false,
    smAndUp: false,
    mdAndDown: false,
    mdOnly: false,
    mdAndUp: false,
    lgAndDown: false,
    lgOnly: false,
    lgAndUp: false,
    xlOnly: false,
  })

  if (import.meta.client) {
    updateBreakpoints(breakpoints, window.innerWidth)
    window.addEventListener('resize', () => {
      updateBreakpoints(breakpoints, window.innerWidth)
    });
  }
  else {
    const headers = useRequestHeaders()
    let screenWidth = headers['viewport-width'] || headers['width']

    if (!screenWidth) {
      const userAgent = headers['user-agent'] || ''
      screenWidth = getScreenWidthFromUserAgent(userAgent)
    }

    updateBreakpoints(breakpoints, screenWidth)
  }

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateBreakpoints)
  });

  return breakpoints
}

function updateBreakpoints(breakpoints = {}, screenWidth) {
  breakpoints.xsOnly = screenWidth <= parseInt(screenBreakpoints.xs)
  breakpoints.smAndDown = screenWidth <= parseInt(screenBreakpoints.sm)

  breakpoints.smOnly = screenWidth > parseInt(screenBreakpoints.xs)
  && screenWidth <= parseInt(screenBreakpoints.sm)

  breakpoints.smAndUp = screenWidth > parseInt(screenBreakpoints.xs)
  breakpoints.mdAndDown = screenWidth <= parseInt(screenBreakpoints.md)
  breakpoints.mdOnly = screenWidth > parseInt(screenBreakpoints.sm)
  && screenWidth <= parseInt(screenBreakpoints.md)

  breakpoints.mdAndUp = screenWidth > parseInt(screenBreakpoints.sm)
  breakpoints.lgAndDown = screenWidth <= parseInt(screenBreakpoints.lg)
  breakpoints.lgOnly = screenWidth > parseInt(screenBreakpoints.md)
  && screenWidth <= parseInt(screenBreakpoints.lg)

  breakpoints.lgAndUp = screenWidth > parseInt(screenBreakpoints.md)
  breakpoints.xlOnly = screenWidth > parseInt(screenBreakpoints.lg)
}

function getScreenWidthFromUserAgent(userAgent) {
  if (/mobile|android|iphone|ipad|phone/i.test(userAgent)) {
    return parseInt(screenBreakpoints.sm)
  }
  else if (/tablet|ipad/i.test(userAgent)) {
    return parseInt(screenBreakpoints.md)
  }
  else {
    return parseInt(screenBreakpoints.lg)
  }
}
